import {
  GET_SALE_LINE_ITEMS,
  ADD_SALE_LINE_ITEM,
  UPDATE_SALE_LINE_ITEM,
  DELETE_SALE_LINE_ITEM,
  GET_SALE_LINE_ITEM,
} from '../types';
import axios from '../../axios';
import { toast } from 'react-toastify';

export const getSalesLineItems = (params) => async (dispatch) => {
  try {
    const res = await axios.get('/sales-line-item/all', { params });

    if (res.data.code === 1) {
      dispatch({ type: GET_SALE_LINE_ITEMS, payload: res.data.data });
    }
  } catch (err) {
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
    // console.error("Failed to get Size. Please try again. :", err);
  }
};

export const addSalesLineItem = (formData) => async (dispatch) => {
  try {
    const res = await axios.post('/sales-line-item/add', formData);

    if (res.data.code === 1) {
      dispatch({ type: ADD_SALE_LINE_ITEM, payload: res.data.data });
      setTimeout(() => {
        toast.success('SalesLineItem added successfully!');
      }, 1000);
    }
    if (res.data.code === 0) {
      setTimeout(() => {
        toast.error(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
  }
};

export const updateSalesLineItem = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`/sales-line-item/update`, formData);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_SALE_LINE_ITEM, payload: res.data.data });

      setTimeout(() => {
        toast.success('SalesLineItem updated successfully!');
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to update Size. Please try again.");
  }
};

export const deleteSalesLineItem = (id) => async (dispatch) => {
  try {
    if (!id) {
      toast.error('Please select any record');
      return false;
    }
    const res = await axios.post(`/sales-line-item/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_SALE_LINE_ITEM, payload: { id } });
      setTimeout(() => {
        toast.success('SalesLineItem deleted successfully!');
      }, 1000);
    }
  } catch (err) {
    if (err.response.data.errors[0].message) {
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to delete Size. Please try again.");
  }
};

export const getSalesLineItem = (id) => async (dispatch) => {
  const res = await axios.get(`/sales-line-item/${id}`);
  if (res.data.code === 1) {
    dispatch({ type: GET_SALE_LINE_ITEM, payload: res.data.data });
  }
  return res.data.code;
};
